<template>
  <div class="commonTitle2 fs-32 c-152338">
    <img v-if="isShowBack" @click="goBack()" src="../assets/public/goBack_icon.svg" class="goBack" />
    <div class="titleText flex-grow-1">
      <slot name="titleText"></slot>
    </div>
    <div @click="onClickTitleRight()" class="titleRight">
      <slot name="titleRight"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'commonTitle2',
    props: {
      isShowBack: {
        type: Boolean,
        default: true
      },
      customGoBack: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {
      goBack() {
        if (this.customGoBack) {
          this.$emit("goBack");
        } else {
          this.$router.go(-1)
        }
      },
      // 点击右侧按钮
      onClickTitleRight() {
        this.$emit("clickRight");
      }
    }
  }
</script>

<style scoped lang="scss">
  .commonTitle2 {
    display: flex;
    align-items: center;
    font-size: 1.8rem;
    color: #FFFFFF;
    padding: 4.1rem 1.6rem 0 1.6rem;
    height: 3rem;

    .goBack {
      width: 3rem;
      height: 3rem;
      border-radius: 0.8rem;
      margin-right: 1.8rem;
    }

    .titleText {}

    .titleRight {
      height: 100%;
      line-height: 3rem;
      flex-shrink: 0;
      color: #333;
      font-size: 1.6rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commonTitle2.vue